import { getDoc, getDocs, query, where } from "firebase/firestore/lite";

import { FirestoreRefs } from "igfd-commons/src/firebase/refs";

import { FirestoreSupplierDocument, Supplier } from "@dashboard/types/supplier";

import { readSupplier } from "./firestore-converter/supplier";

export interface SupplierApi {
  fetchSuppliers(): Promise<Supplier[]>;
}

/**
 * An implementation of the SupplierApi that uses Firestore as the backend.
 * Note: Suppliers are read-only from the application and managed via kitchen, or integration.
 */
export class FirestoreBackedSupplierApi implements SupplierApi {
  private firestoreRefs: FirestoreRefs;

  constructor(params: { firestoreRefs: FirestoreRefs }) {
    this.firestoreRefs = params.firestoreRefs;
  }

  public async fetchSuppliers(): Promise<Supplier[]> {
    const q = query(
      this.firestoreRefs.suppliers(),
      where("isDeleted", "==", false)
    );

    const querySnapshot = await getDocs(q);

    return querySnapshot.docs
      .map((doc) => doc.data() as FirestoreSupplierDocument)
      .map(readSupplier);
  }
}
